import { Box } from '@mui/material';
import { ChatBubble } from 'modules';
import { useRef } from 'react';



export type NoCompanyActivityProps = {};

export const NoCompanyActivity = (props: NoCompanyActivityProps) => {
  const slideRef = useRef<HTMLDivElement>(null);

  return (
    <Box sx={{
      py: '1rem'
    }}
    >
      <ChatBubble.FC
        slideRef={slideRef}
        variant='info'
        role='SHERLOCK'
        text={`👋I've generated company sentiment analysis for you.  In order to start, please select a company from the left`}
      />

      <div ref={slideRef} />
    </Box>
  );
};
